let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2yaCV")).then(() => parcelRequire('l3z6A'));